export default __webpack_public_path__ + "static/media/background.b00eaa90.jpg";